import { render, staticRenderFns } from "./FormRadioGroup.vue?vue&type=template&id=0bdef29e&"
import script from "./FormRadioGroup.vue?vue&type=script&lang=js&"
export * from "./FormRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports